import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";

// OrderHistoryTable
orderHistoryTableStyles.reorderButton = {
    color: "primary",
    sizeVariant: "medium",
};
